export enum CallStartError {
    unknown = 'unknown',
    isHandledByOther = 'isHandledByOther',
}
